module.exports = __webpack_public_path__ + "img/messenger_logo.ffce13a5.png";